import { render, staticRenderFns } from "./loudspeaker.vue?vue&type=template&id=71fd7044"
import script from "./loudspeaker.vue?vue&type=script&lang=js"
export * from "./loudspeaker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports